import { useEffect } from 'react'

import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck'
import i18n from 'src/i18n'
import clsx from 'clsx'
import { ScreenSizes } from 'src/styles'
import { useMediaQuery } from '@hotmart/space-lib/dist/hooks'
import { TIME_TO_CLOSE_MODAL } from './constants'
import type { SuccessProps } from './types'
import { CustomIcon } from './success.styles'

const Success = ({ onCloseModal }: SuccessProps) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)

  useEffect(() => {
    const timer = setTimeout(onCloseModal, TIME_TO_CLOSE_MODAL)
    return () => clearTimeout(timer)
  }, [onCloseModal])

  return (
    <div className="_d-flex _flex-column _align-items-center">
      <CustomIcon icon={faCircleCheck} />
      <h1
        className={clsx('_font-weight-light _text-4 _text-gray-700 _mb-1 _mt-4', {
          '_text-center	': isMobile
        })}
      >
        {i18n.t('community_survey.create_community.success.title')}
      </h1>
      <h2
        className={clsx('_font-weight-light _text-4 _text-gray-700 _mb-0', {
          '_text-center	': isMobile
        })}
      >
        {i18n.t('community_survey.create_community.success.description')}
      </h2>
      <p
        className={clsx('_font-weight _text-2 _text-gray-500 _mt-4 _mb-7', {
          '_text-center	': isMobile
        })}
      >
        {i18n.t('community_survey.create_community.success.second_description')}
      </p>
    </div>
  )
}

export default Success
